var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmpanyocumentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#C1D7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12L17.3 10.375C17.49 10.138 17.777 10 18.081 10H21.92C22.224 10 22.511 10.138 22.701 10.375L24 12V12V13C24 13.552 23.552 14 23 14H17C16.448 14 16 13.552 16 13V12V12H16Z",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H14C12.895 12 12 12.895 12 14V27C12 28.105 12.895 29 14 29H26C27.105 29 28 28.105 28 27V14C28 12.895 27.105 12 26 12H24",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19H24",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H24",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmpanyocumentationIcon);
export default __webpack_public_path__ + "static/media/СompanyВocumentationIcon.0496877b117383c13d07d83612f2a795.svg";
export { ForwardRef as ReactComponent };